module.exports = __webpack_public_path__ + "icon-account-17a5b9b1.png";